import React from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Avatar from '@material-ui/core/Avatar'

export default ({ checked, label, text, image, labelId, onChange }) => (
	<ListItem button onClick={onChange}>
        <Avatar src={image} alt='' />
        <ListItemText primary={label} secondary={text} id={labelId}/>
        <Checkbox checked={checked} inputProps={{ 'aria-labelledby': labelId }} />
    </ListItem>
)


// WEBPACK FOOTER //
// ./src/components/Filter/Checkbox.js